// extracted by mini-css-extract-plugin
export default {"expired":"expired_expired__hBigp"};